@use "~theme/breakpoints";
@use "~theme/typographyV2" as typography;

.knownPatientSchedule {
  background: var(--canvas-tan);
  font-family: typography.$font-mont;
  min-height: 100vh;
}

.scheduleShell {
  display: block;
  overflow: auto;
  padding: 0;

  @media screen and (max-width: 991px) {
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;
    width: 100%;
  }
}

.mobileSchedule {
  background: var(--canvas-tan);
  box-sizing: border-box;
  font-family: typography.$font-mont;
  overflow: hidden;
  padding: 0;
  width: 100%;
}

.mobileIntroCard {
  background: var(--white);
  border: 1px solid var(--gray-07);
  border-radius: 12px;
  box-shadow: 0 2px 6px var(--gray-03);
  margin: 16px 16px 0;
  overflow: hidden;

  > div,
  > section {
    border: 0;
    border-radius: 0;
    box-shadow: none !important;
    margin: 0;
  }

  > section:last-child {
    border-bottom: 0;
  }

  > div:first-child {
    border-bottom: 1px solid var(--gray-07);
  }
}

.mobileIntroCardExpanded {
  > div:nth-child(2) {
    border-bottom: 1px solid var(--gray-07);
  }

  > section:last-child {
    border-top: 1px solid var(--gray-07);
  }
}

.mobileNearbyHeading {
  color: var(--brand-indigo);
  font-family: typography.$font-mont;
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  padding: 12px 16px 2px;
}

.loadingScheduleColumn {
  background-color: var(--canvas-tan);
  display: block;
  float: none;
  margin: 0;
  overflow: hidden;
  padding: 0 20px;
  width: 100%;

  @media screen and (max-width: 991px) {
    box-sizing: border-box;
  }

  @include breakpoints.desktop {
    float: left;
    margin-top: 10px;
    overflow: auto;
    padding: 0 0 0 20px;
    width: 67%;
  }
}

.loadingHeadline,
.loadingDivider,
.loadingDateCard,
.loadingDoctorCard,
.loadingAvatar,
.loadingSlot,
.loadingRailCard {
  animation: pulse 1.2s ease-in-out infinite;
  background: var(--white);
}

.loadingHeadline {
  border-radius: 12px;
  height: 104px;
  margin-top: 16px;
  width: 100%;

  @include breakpoints.desktop {
    border-radius: 20px;
    height: 41px;
    margin-top: 0;
    width: 340px;
  }
}

.loadingDivider {
  display: none;

  @include breakpoints.desktop {
    background: var(--brand-indigo);
    display: block;
    height: 2px;
    margin: 0 0 9px;
    width: 270px;
  }
}

.loadingDateRow {
  align-items: center;
  background: var(--white);
  display: flex;
  gap: 6px;
  height: 96px;
  margin-bottom: 20px;
  margin-left: -20px;
  margin-right: -20px;
  margin-top: 16px;
  padding: 28px 12px 12px;
  width: auto;

  @media screen and (max-width: 991px) {
    box-sizing: border-box;
  }

  @include breakpoints.desktop {
    background: transparent;
    gap: 16px;
    height: 90px;
    margin: 16px 0 18px;
    padding: 0 16px 0 0;
    width: auto;
  }
}

.loadingDateCard {
  border: 1px solid var(--gray-03);
  border-radius: 10px;
  box-shadow: 0 4px 8px var(--gray-03);
  flex: 0 0 calc((100% - 24px) / 5);
  height: 56px;
  min-width: 0;

  &:nth-child(6) {
    display: none;
  }

  @include breakpoints.desktop {
    border-radius: 20px;
    flex: 1 1 0;
    height: 80px;
    max-width: 150px;

    &:nth-child(6) {
      display: block;
    }
  }
}

.loadingDoctorCard {
  align-items: flex-start;
  background: var(--white);
  border: 1px solid var(--gray-03);
  border-radius: 16px;
  display: grid;
  gap: 12px;
  grid-template-columns: 48px minmax(0, 1fr);
  margin-bottom: 12px;
  min-height: 250px;
  padding: 16px 12px;

  @include breakpoints.desktop {
    border: 0;
    border-bottom: 1px solid var(--gray-03);
    border-radius: 0;
    gap: 18px;
    grid-template-columns: 64px minmax(150px, 210px) minmax(0, 1fr);
    margin-bottom: 0;
    min-height: 178px;
    padding: 28px 24px;
  }
}

.loadingAvatar {
  border-radius: 50%;
  height: 48px;
  width: 48px;

  @include breakpoints.desktop {
    height: 58px;
    width: 58px;
  }
}

.loadingDoctorDetails {
  padding-top: 8px;
}

.loadingSlots {
  display: grid;
  gap: 8px;
  grid-column: 1 / -1;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  @include breakpoints.desktop {
    display: flex;
    flex-wrap: wrap;
    gap: 18px 12px;
    grid-column: auto;
  }
}

.loadingSlot {
  border: 1px solid var(--blue-01-at-30);
  border-radius: 10px;
  height: 32px;
  width: 100%;

  @include breakpoints.desktop {
    height: 38px;
    width: 112px;
  }
}

.loadingRailCard {
  background: var(--white);
  border-radius: 20px;
  box-shadow: 0 4px 8px var(--gray-03);
  min-height: 180px;
  margin-top: 10px;

  @media screen and (max-width: 991px) {
    display: none;
  }
}

.reviewOverlay {
  background: var(--black-at-75);
  overflow: hidden;
}

.reviewModal {
  border: 0;
  border-radius: 12px;
  box-sizing: border-box;
  margin: 12px;
  max-height: calc(100dvh - 24px);
  max-width: 1088px;
  overflow: hidden;
  padding: 0;
  width: calc(100vw - 24px);

  @include breakpoints.desktop {
    border-radius: 20px;
    margin: 36px 48px;
    max-height: calc(100dvh - 72px);
    width: min(1088px, calc(100vw - 96px));
  }
}

.reviewModalContent {
  display: flex;
  margin-top: 0;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
  width: 100%;
}

.reviewContent {
  @include typography.body;
  color: var(--blue-01);
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  max-height: calc(100dvh - 24px);
  min-height: 0;
  overflow: hidden;
  position: relative;

  @include breakpoints.desktop {
    max-height: calc(100dvh - 72px);
  }
}

.reviewHeader {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  flex: 0 0 auto;
  margin-bottom: 0;
  padding: 10px 44px 8px 12px;

  @include breakpoints.desktop {
    padding: 28px 72px 22px 30px;
  }

  h1 {
    color: var(--brand-indigo);
    font-family: typography.$font-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
    line-height: 31px;
    margin: 0;

    @include breakpoints.desktop {
      font-size: 32px;
      line-height: 41px;
      white-space: nowrap;
    }
  }
}

.reviewTitlePrimary,
.reviewTitleSupporting {
  display: inline;
}

.reviewTitleSupporting {
  display: block;
  font-family: typography.$font-mont;
  font-size: 11px;
  font-weight: 400;
  line-height: 15px;

  @include breakpoints.desktop {
    display: inline;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
}

.reviewBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0 12px 12px;

  @include breakpoints.desktop {
    padding: 0 30px 22px;
  }
}

.reviewFooter {
  background: var(--white);
  border-top: 1px solid var(--gray-08);
  flex: 0 0 auto;
  padding: 8px 12px 10px;

  @include breakpoints.desktop {
    padding: 18px 30px 24px;
  }
}

.modalCloseButton {
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 6px;
  position: absolute;
  right: 24px;
  top: 16px;
  width: 32px;

  img {
    filter: brightness(0) saturate(100%) invert(88%) sepia(0%) saturate(0%)
      hue-rotate(204deg) brightness(91%) contrast(89%);
    height: 18px;
    width: 18px;
  }

  @include breakpoints.desktop {
    right: 48px;
    top: 20px;

    img {
      height: 26px;
      width: 26px;
    }
  }
}

.reviewSectionHeader {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;

  @include breakpoints.desktop {
    margin-bottom: 10px;
  }
}

.changeButton {
  align-items: center;
  background: transparent;
  border: 0;
  color: var(--blue-01);
  cursor: pointer;
  display: inline-flex;
  font-family: typography.$font-mont;
  font-size: 10px;
  gap: 3px;
  font-weight: 400;
  letter-spacing: 0.05em;
  line-height: 140%;
  padding: 0;
  text-decoration: underline;
  text-underline-offset: 1px;
  white-space: nowrap;

  img {
    height: 12px;
    flex: 0 0 auto;
    width: 12px;
  }

  @include breakpoints.desktop {
    font-size: 12px;
    gap: 4px;

    img {
      height: 16px;
      width: 16px;
    }
  }
}

.appointmentSummary {
  background: var(--gray-05);
  border-radius: 8px;
  color: var(--blue-01);
  display: grid;
  font-family: typography.$font-mont;
  font-size: 11px;
  line-height: 140%;
  gap: 6px;
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 12px;
  padding: 10px;

  @include breakpoints.desktop {
    border-radius: 20px;
    column-gap: 42px;
    font-size: 14px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: repeat(3, auto);
    min-height: 124px;
    padding: 20px 26px;
    row-gap: 14px;
  }

  div {
    display: grid;
  }

  strong {
    font-weight: 700;
  }

  span {
    overflow-wrap: anywhere;
  }
}

.summaryDoctor {
  @include breakpoints.desktop {
    grid-column: 1;
    grid-row: 1;
  }
}

.summaryDoctorVEH {
  &.summaryRow {
    grid-template-columns: 32px minmax(0, 1fr);
  }
}

.summaryLocation {
  align-items: start;
  padding-top: 0;

  @include breakpoints.desktop {
    align-self: start;
    grid-column: 2;
    grid-row: 1 / span 3;
  }
}

.summaryDate {
  @include breakpoints.desktop {
    grid-column: 1;
    grid-row: 2;
  }
}

.summaryTime {
  @include breakpoints.desktop {
    grid-column: 1;
    grid-row: 3;
  }
}

.summaryRow {
  align-items: center;
  display: grid;
  gap: 8px;
  grid-template-columns: 20px minmax(0, 1fr);

  @include breakpoints.desktop {
    gap: 12px;
    grid-template-columns: 30px minmax(0, 1fr);
  }
}

.doctorThumb {
  align-items: center;
  border-radius: 50%;
  color: var(--blue-01);
  display: inline-flex;
  font-size: 7px;
  height: 18px;
  justify-content: center;
  width: 18px;

  @include breakpoints.desktop {
    font-size: 9px;
    height: 24px;
    width: 24px;
  }
}

.summaryGraphic {
  height: 16px;
  object-fit: contain;
  width: 16px;

  @include breakpoints.desktop {
    height: 22px;
    width: 22px;
  }
}

.locationGraphic {
  align-self: start;
  height: 16px;
  margin-top: 0;
  width: 16px;

  @include breakpoints.desktop {
    height: 22px;
    width: 22px;
  }
}

.doctorThumb {
  object-fit: cover;
}

.doctorThumbVEH {
  background-color: var(--white);
  border-radius: 20px;
  height: 32px;
  object-fit: contain;
  width: 48px;

  @include breakpoints.desktop {
    height: 30px;
    width: 30px;
  }
}

.addressBlock {
  gap: 1px;

  @include breakpoints.desktop {
    gap: 4px;
  }
}

.radioGroup {
  display: flex;
  flex-flow: column nowrap;
  gap: 4px;
  margin-top: 6px;

  @include breakpoints.desktop {
    flex-flow: row wrap;
    gap: 22px;
    margin-top: 12px;
  }
}

.container {
  background: var(--canvas-tan);
  font-family: typography.$font-mont;
  min-height: calc(100vh - 96px);
  padding: 16px;

  @include breakpoints.desktop {
    padding: 24px 32px 0;
  }
}

.pageGrid {
  display: grid;
  gap: 16px;
  margin: 0 auto;
  max-width: 1120px;

  @include breakpoints.desktop {
    grid-template-columns: minmax(0, 1120px);
    align-items: start;
    justify-content: center;
    gap: 0;
  }
}

.primaryColumn,
.detailsColumn {
  display: grid;
  gap: 12px;
}

.primaryColumn {
  @include breakpoints.desktop {
    display: block;
  }
}

.detailsColumn {
  @include breakpoints.desktop {
    display: none;
  }
}

.summaryCard,
.infoCard,
.stateCard {
  background: var(--white);
  border-radius: 20px;
  box-shadow: 0 2px 6px var(--gray-03);
  color: var(--blue-01);
  font-family: typography.$font-mont;
}

.summaryCard {
  padding: 18px;

  @include breakpoints.desktop {
    display: none;
  }
}

.infoCard,
.stateCard {
  padding: 18px;
}

.summaryPanel {
  background: var(--blue-03);
  border-radius: 20px;
  padding: 12px;

  @include breakpoints.desktop {
    padding: 12px 14px;
  }
}

.personalDetails {
  margin-top: 12px;

  @include breakpoints.desktop {
    margin-top: 20px;
  }
}

.personalQuestionGroup {
  display: contents;
}

.panelTitle {
  color: var(--blue-01);
  font-family: typography.$font-mont;
  font-size: 10px;
  font-weight: var(--semibold-weight);
  letter-spacing: 0.02rem;
  line-height: 140%;
  margin-bottom: 6px;
  text-transform: none;

  @include breakpoints.desktop {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.question {
  color: var(--blue-01);
  font-family: typography.$font-mont;
  font-size: 12px;
  font-weight: var(--semibold-weight);
  letter-spacing: 0.02rem;
  line-height: 140%;
  margin: 0;

  @include breakpoints.desktop {
    font-size: 16px;
    max-width: none;
    white-space: nowrap;
  }
}

.radioRow {
  align-items: center;
  color: var(--blue-02);
  display: flex;
  font-family: typography.$font-mont;
  font-size: 10px;
  font-weight: 400;
  gap: 5px;
  letter-spacing: 0.02rem;
  line-height: 140%;
  margin-top: 0;

  input {
    accent-color: var(--blue-01);
    height: 12px;
    margin: 0;
    width: 12px;
  }

  @include breakpoints.desktop {
    font-size: 14px;
    gap: 8px;
    margin-top: 6px;

    input {
      height: 16px;
      width: 16px;
    }
  }
}

.detailList {
  margin: 0;

  div {
    display: grid;
    gap: 2px;
    margin-top: 10px;

    &:first-child {
      margin-top: 0;
    }
  }

  @include breakpoints.desktop {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 8px 18px;

    div {
      margin-top: 0;
    }

    div:first-child {
      grid-row: span 2;
    }
  }

  dt {
    @include typography.small-text;
    color: var(--blue-02);
    font-weight: 600;

    @include breakpoints.desktop {
      font-size: 11px;
    }
  }

  dd {
    @include typography.caption-semibold;
    color: var(--blue-01);
    margin: 0;
    overflow-wrap: anywhere;

    @include breakpoints.desktop {
      font-size: 12px;
      line-height: 1.35;
    }
  }
}

.desktopDetailsGrid,
.desktopPreferences {
  display: grid;
}

.desktopDetailsGrid {
  gap: 8px;
  grid-template-columns: minmax(0, 1fr);
  margin-top: 12px;

  @include breakpoints.desktop {
    gap: 16px 18px;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    margin-top: 24px;

    .field:nth-child(1),
    .field:nth-child(2) {
      grid-column: span 6;
    }

    .field:nth-child(3) {
      grid-column: span 2;
    }

    .field:nth-child(4),
    .fieldWide {
      grid-column: span 5;
    }
  }
}

.field,
.fieldWide {
  min-width: 0;
}

.dateInputIcon {
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  height: 16px;
  justify-content: center;
  left: 12px;
  padding: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;

  img {
    height: 14px;
    width: 14px;
  }

  &:disabled {
    cursor: default;
    opacity: 0.65;
  }
}

.fieldWide {
  @include breakpoints.desktop {
    grid-column: span 2;
  }
}

.fieldLabel {
  color: var(--blue-01);
  font-family: typography.$font-mont;
  font-size: 10px;
  font-weight: var(--semibold-weight);
  letter-spacing: 0.02rem;
  line-height: 140%;
  margin-bottom: 3px;

  @include breakpoints.desktop {
    font-size: 14px;
    margin-bottom: 6px;
  }
}

.fieldInput {
  background: var(--blue-03);
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--blue-01);
  display: block;
  font-family: typography.$font-mont;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.02rem;
  line-height: 140%;
  min-height: 40px;
  padding: 9px 10px;
  width: 100%;

  &:enabled {
    background: var(--white);
    border-color: var(--blue-01-at-30);
  }

  &:focus {
    border-color: var(--blue-01);
    box-shadow: 0 0 0 2px var(--blue-01-at-30);
    outline: 0;
  }

  &:disabled {
    background: var(--blue-03);
    border-color: var(--blue-01-at-30);
    border-style: dashed;
    color: var(--blue-02);
    cursor: default;
    opacity: 1;
    -webkit-text-fill-color: var(--blue-02);
  }

  @include breakpoints.desktop {
    font-size: 14px;
    min-height: 46px;
    padding: 12px 14px;
  }
}

.dateField {
  position: relative;

  .fieldInput {
    padding-left: 36px;

    &::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
  }
}

.infoCard {
  h2 {
    font-family: typography.$font-mont;
    font-size: 14px;
    font-weight: var(--semibold-weight);
    letter-spacing: 0.02rem;
    line-height: 140%;
    color: var(--blue-01);
    margin: 0 0 12px;
  }
}

.desktopPreferences {
  gap: 8px;
  margin-top: 12px;

  > label {
    font-size: 10px;
    line-height: 14px;
    margin-bottom: 0;
  }

  @include breakpoints.desktop {
    display: grid;
    gap: 14px;
    margin-top: 26px;

    > label {
      font-size: 12px;
      line-height: 140%;
    }
  }
}

.primaryButton {
  min-height: 40px;
  margin-top: 0;
  width: 100%;

  @include breakpoints.desktop {
    border-radius: 999px;
    height: 56px;
    min-height: 56px;
    text-transform: none;

    span {
      font-size: 16px;
      letter-spacing: 0;
    }
  }
}

@media screen and (max-width: 991px) {
  .reviewModal {
    border: 1px solid #cccccc;
    border-radius: 16px;
    height: min(700px, calc(100dvh - 32px));
    margin: 16px;
    max-height: calc(100dvh - 32px);
    max-width: 358px;
    width: calc(100vw - 32px);
  }

  .reviewModalContent {
    height: 100%;
  }

  .reviewContent {
    color: var(--brand-indigo);
    max-height: 100%;
  }

  .reviewHeader {
    box-sizing: border-box;
    height: 71px;
    padding: 16px 72px 0 24px;

    h1 {
      display: flex;
      flex-direction: column;
      font-size: 32px;
      gap: 4px;
      letter-spacing: 0;
      line-height: 110%;
    }
  }

  .reviewTitleSupporting {
    font-size: 16px;
    line-height: 100%;
  }

  .reviewBody {
    padding: 24px;

    > section:first-child {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .reviewFooter {
    background: #f4f6f8;
    border-top-color: #cccccc;
    padding: 16px 20px 24px;
  }

  .modalCloseButton {
    padding: 0;

    img {
      height: 20px;
      width: 20px;
    }
  }

  .reviewSectionHeader {
    margin-bottom: 0;
  }

  .changeButton {
    font-size: 12px;
    gap: 6px;
    letter-spacing: 0;
    line-height: 15px;

    img {
      height: 14px;
      width: 14px;
    }
  }

  .appointmentSummary {
    border-radius: 12px;
    box-sizing: border-box;
    color: var(--brand-indigo);
    font-size: 16px;
    font-weight: 500;
    gap: 8px;
    line-height: 150%;
    margin-bottom: 0;
    min-height: 230px;
    padding: 16px;

    strong {
      font-weight: 600;
    }
  }

  .summaryDoctor {
    line-height: 160%;
  }

  .summaryDate {
    line-height: 160%;
  }

  .summaryTime {
    line-height: 160%;
  }

  .summaryLocation {
    line-height: 150%;
  }

  .summaryRow {
    grid-template-columns: 24px minmax(0, 1fr);
  }

  .doctorThumb,
  .summaryGraphic,
  .locationGraphic {
    height: 24px;
    width: 24px;
  }

  .addressBlock {
    gap: 0;
  }

  .personalDetails {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }

  .personalQuestionGroup {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .panelTitle {
    color: var(--brand-indigo);
    font-size: 14px;
    letter-spacing: 0;
    line-height: 150%;
    margin-bottom: 0;
  }

  .question {
    color: var(--brand-indigo);
    font-size: 16px;
    letter-spacing: 0;
    line-height: 150%;
  }

  .radioGroup {
    flex-flow: row wrap;
    gap: 16px;
    margin-top: 0;
  }

  .radioRow {
    color: #333333;
    font-size: 14px;
    font-weight: 500;
    gap: 4px;
    letter-spacing: 0;
    line-height: 130%;

    input {
      height: 20px;
      width: 20px;
    }
  }

  .desktopDetailsGrid {
    gap: 16px;
    margin-top: 0;
  }

  .field,
  .fieldWide {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .fieldLabel {
    color: var(--brand-indigo);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 110%;
    margin-bottom: 0;
  }

  .fieldInput {
    border-radius: 8px;
    color: var(--brand-indigo);
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 110%;
    padding: 9px 12px;

    &:disabled {
      border-color: #bce7f3;
      color: var(--brand-indigo);
      -webkit-text-fill-color: var(--brand-indigo);
    }
  }

  .desktopPreferences {
    gap: 12px;
    margin-top: 0;

    > label {
      font-size: 12px;
      line-height: 16.8px;
    }
  }

  .primaryButton {
    border-radius: 999px;
    height: 46px;
    min-height: 46px;
    text-transform: none;

    span {
      font-size: 16px;
      letter-spacing: 0;
    }
  }
}

.stateCard {
  margin: 0 auto;
  max-width: 520px;
}

.stateTitle {
  color: var(--blue-01);
  font-family: typography.$font-mont;
  font-size: 24px;
  font-weight: var(--semibold-weight);
  line-height: 140%;
  margin: 0;
}

.stateBody {
  @include typography.caption;
  color: var(--blue-02);
  margin: 8px 0 0;
}

.actions {
  margin-top: 16px;
}

.link {
  @include typography.caption-semibold-link;
  color: var(--blue-01);
}

.loadingLine,
.loadingLineShort {
  animation: pulse 1.2s ease-in-out infinite;
  background: var(--gray-04);
  border-radius: 8px;
  height: 14px;
  margin-top: 14px;
}

.loadingLineShort {
  width: 60%;
}

.screenReaderOnly {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.45;
  }
}
